export type { LoadingIndicatorProps } from './loading-indicator';
export { default } from './loading-indicator';
